import Text from "../../../../Components/Text";
import React, { useState, useEffect } from "react";
import Form from "../../../../Components/Form";
import TextInput from "../../../../Components/Form/TextInput";
import NumberInput from "../../../../Components/Form/NumberInput";
import Extra from "../../../../APIController/Extra";

const ExtraForm = ({ selectedExtra = null, afterAction }) => {
    const { createExtra, editExtra } = Extra()

    //Attributes
    const [extraName, setExtraName] = useState("")
    const [extraPrice, setExtraPrice] = useState(null)

    useEffect(() => {
        if (selectedExtra) {
            setExtraName(selectedExtra.name)
            setExtraPrice(selectedExtra.price)
        }
    }, [])

    const handleAddExtra = async (extraDTO) => {
        await createExtra(extraDTO)
        afterAction()
    }

    const handleEditExtra = async (id, extraDTO) => {
        await editExtra(id, extraDTO)
        afterAction()
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const extraDTO = {
            name: extraName,
            price: extraPrice
        }

        if (selectedExtra) {
            handleEditExtra(selectedExtra.id, extraDTO)
        } else {
            handleAddExtra(extraDTO)
        }
    }

    /* Form  */
    return (
        <Form onSubmitAction={handleSubmit} submitButtonText={selectedExtra ? "Extra bearbeiten" : "Extra erstellen"}>
            <Text type="maintitle" classNames={"flex text-center justify-center"}> {selectedExtra ? "Extra bearbeiten" : "Extra erstellen"}</Text>
            <div className="mb-4">
                <TextInput attribute={extraName} id={"extraName"} label={"Name"} placeholder={"Extra Name"} action={(e) => setExtraName(e.target.value)}/>
                <NumberInput attribute={extraPrice} id={"extraPrice"} label={"Preis"} placeholder={"Extra Preis"} action={(e) => setExtraPrice(e.target.value)} />
            </div>
        </Form>
    )
}
export default ExtraForm